<template>
  <form v-on:submit="save">
    <div class="card card-info">
      <div class="card-header with-border">
        <h3 class="card-title">Merit List</h3>
      </div>
      <div id="studentForm">
        <div class="card-body" style="padding-right: 2%; padding-left: 2%">

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Session *</label>
                <select required class="form-control" v-model="merit.ActiveSemesterID" v-on:change="semesterChange()" id="ddlSession">
                  <option value="0" selected="selected" disabled="disabled">--Select Session--</option>
                  <option v-for="item in semesters" v-bind:value="item.SemesterID">{{item.Name}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Degree *</label>
                <select required class="form-control" v-on:change="degreeChange()" v-model="merit.DegreeID">
                  <option value="0" selected="selected" disabled="disabled">--Select Degree--</option>
                  <option v-for="item in degrees" v-bind:value="item.DegreeID">{{item.Name}}</option>
                </select>
              </div>
            </div>
            <!--<div class="col-md-4">
              <div class="form-group">
                <label>Admission Type *</label>
                <select required class="form-control" v-model="merit.AdmissionType">
                  <option value="Regular">Regular</option>
                  <option value="Self-Support">Self-Support</option>
                </select>
              </div>
            </div>-->

            <div class="col-md-4">
              <div class="form-group">
                <label>Program *</label>
                <select required class="form-control" v-model="merit.ProgramID">
                  <option value="" selected="selected" disabled="disabled">--Select Program--</option>
                  <option v-for="item in programs" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
                </select>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Category *</label>
                <select required class="form-control" v-model="merit.AdmissionCategoryID">
                  <option value="0" selected="selected" disabled="disabled">--Select Category--</option>
                  <option v-for="item in categories" v-bind:value="item.AdmissionCategoryID"> {{item.Name}}</option>
                </select>
              </div>
            </div>

            <div class="col-md-8">
              <div class="form-group">
                <label>Title *</label>
                <input class="form-control" v-model="merit.Name" maxlength="100" />
              </div>
            </div>

          </div>
          <div class="row">
            <div class="col-md-2 com-sm-4">
              <div class="form-group">
                <label>Select by</label>
                <select class="form-control" v-model="merit.Type">
                  <option value="Range">Range</option>
                  <option value="Top">No of Student</option>
                </select>
              </div>
            </div>

            <div class="col-md-2 com-sm-4" v-if="merit.Type == 'Range'">
              <div class="form-group">
                <label>Range From *</label>
                <input required v-mask="'###'" placeholder="min" v-model="merit.MinimumAggregate" class="form-control" />
              </div>
            </div>

            <div class="col-md-2 com-sm-4" v-if="merit.Type == 'Range'">
              <div class="form-group">
                <label>Range To *</label>
                <input required v-mask="'###'" v-model="merit.MaximumAggregate" placeholder="max" class="form-control" />
              </div>
            </div>

            <div class="col-md-2 com-sm-4" v-if="merit.Type == 'Top'">
              <div class="form-group">
                <label>Show Top *</label>
                <input required v-mask="'###'" v-model="top" placeholder="Top 100 Students" class="form-control" />
              </div>
            </div>

            <div class="col-md-2 com-sm-4">
              <div class="form-group">
                <label>Students in waiting list *</label>
                <input required v-mask="'##'" placeholder="no of students" v-model="waiting" class="form-control" />
              </div>
            </div>

            <!--<div class="col-md-2" v-if="merit.InterviewOffered">
              <div class="form-group">
                <label>Internal Test</label>
                <select class="form-control" v-model="merit.Interview">
                  <option value="NAN">Not Required</option>
                  <option value="Appeared">Required</option>
                </select>
              </div>
            </div>

            <div class="col-md-4" v-if="merit.Interview == 'Appeared'">
              <div class="form-group">
                <label>Min. Score in Internal Test *</label>
                <input required v-mask="'###'" v-model="merit.InterviewScore" placeholder="50" class="form-control" />
              </div>
            </div>-->

            <div class="col-md-2 com-sm-4">
              <div class="form-group">
                <label>External Test</label>
                <select class="form-control" v-model="merit.TestID">
                  <option value="0">Not Required</option>
                  <option v-for="item in tests" v-bind:value="item.AggregateTypeID">{{item.Name}}</option>
                </select>
              </div>
            </div>

            <div class="col-md-2 com-sm-4" v-if="merit.TestID != 0 && merit.TestID != '0' ">
              <div class="form-group">
                <label>Min. Score in {{tests.find(x => x.AggregateTypeID == merit.TestID).Name}} *</label>
                <input required v-mask="'###'" v-model="merit.TestScore" class="form-control" />
              </div>
            </div>

            <div class="col-md-2 com-sm-4">
              <div class="form-group">
                <label>Effective From *</label>
                <input v-model="merit.EffectiveFrom" type="date" class="form-control" required />
              </div>
            </div>
            <div class="col-md-2 com-sm-4">
              <div class="form-group">
                <label>Effective To *</label>
                <input v-model="merit.EffectiveTo" type="date" class="form-control" required />
              </div>
            </div>
            <div class="col-md-2 com-sm-4">
              <div class="form-group">
                <label>Department Contact No.*</label>
                <input v-model="merit.DepartmentPhoneNo" v-mask="'###########'" class="form-control" required />
              </div>
            </div> 
            <div class="col-md-12 ">
              <button class="btn btn-success pull-right" style="margin-left:2px" type="button" v-on:click="loadCandidates()">load Students</button>
             
              <hr />
            </div>
          </div>

          <div class="row" v-show="candidates.length > 0">
            <div class="col-md-12">
              <label>Student List</label>
              <div style="max-height: 700px; overflow-y: scroll">
                <table class="table table-sm table-bordered table-color">
                  <thead class="bg-info text-white">
                    <tr>
                      <th>Sr No.</th>
                      <th style="width: 10%; text-align: center">Form No</th>
                      <th style="width: 30%;">Name</th>
                      <th style="width: 30%;">Father Name</th>
                      <th style="width: 10%;">Merit</th>
                      <th style="width: 10%;">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in candidates">
                      <td style="text-align: center">{{index + 1}}</td>
                      <td style="text-align: center">{{item.FormNo}}</td>
                      <td style="">{{item.Name}}</td>
                      <td style="">{{item.FathersName}}</td>
                      <td style="">{{item.Aggregate.toFixed(3)}}</td>
                      <td style="">Recommended</td>
                    </tr>
                    <tr v-for="(item, index) in waitingList">
                      <td style="text-align: center">{{candidates.length + index + 1}}</td>
                      <td style="text-align: center">{{item.FormNo}}</td>
                      <td style="">{{item.Name}}</td>
                      <td style="">{{item.FathersName}}</td>
                      <td style="">{{item.Aggregate.toFixed(3)}}</td>
                      <td style="">Waiting</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-md-12" style="padding-bottom: 75px">
              <div class="form-group">
                <label>Header Text </label>
                <quill-editor v-model="merit.Header" />
              </div>
            </div>
            <div class="col-md-12" style="padding-bottom: 75px">
              <div class="form-group">
                <label>Footer Text </label>
                <quill-editor v-model="merit.Footer" />
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer" style="text-align: right">
          <input type="submit" v-if="isupdate == false" class="btn btn-success float-right" />
          <!--<button type="button" v-show="isupdate == false" class="btn btn-success" v-on:click="newEntryTest()">Save</button>-->
          <button type="button" v-show="isupdate == true" class="btn btn-success" v-on:click="updateEntryTest()">Update</button>
          <button type="button" class="btn btn-primary float-left" v-on:click="Cancel()">Back To List</button>

        </div>
      </div>
      
    </div>
  </form>
</template>

<script>
  const axios = require('axios').default;

  /*import { VueEditor } from "vue2-editor";*/

  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'

  import { quillEditor } from 'vue-quill-editor'

  export default ({
    components: {
      //VueEditor
      //"vue-html-editor": VueEditor
      quillEditor
    },
    data() {
      return {
        isupdate: false,
        programs: [],
        degrees: [],
        semesters: [],
        merit: { Header: '', Footer: '<div><p><strong>Note: Error and Omission Excepted</strong></p><p>It is a provisional merit list. Final recommendations will be made by the respective departments after the verification of the original documents of the candidates. Age limit remains 22 years for all the disciplines. The overage candidates seeking relaxation can only be accommodated after the exhaustion.</p><p><br></p><p><strong>Admission Committee</strong>:</p><p>1.________________ 2.________________ 3.________________</p><p><br></p><p><strong>Chairman:</strong></p><p><strong>__________________</strong></p></div>', Name: '', DepartmentPhoneNo: '', EffectiveFrom: '', EffectiveTo: '', ProgramID: '', AdmissionCategoryID: 0, SessionID: 0, DegreeID: 0, ActiveSemesterID: 0, MaximumAggregate: '', MinimumAggregate: '', AdmissionType: "Regular", Type: 'Top', GatOffered: false, InterviewOffered: false, Gat: 'NAN', GatScore: '50', Interview: 'NAN', InterviewScore: '50', TestID: 0, TestScore: 50 },
        candidates: [],
        top: 100,
        waiting: 0,
        programId: '',
        tests: [], categories: [],
        waitingList: [],

        content: '<p>Content of the editor.</p>',
      }
    },

    mounted: function () {
      this.checkMeritListUpdate();
    },

    methods: {
      Cancel() {
        window.location.href = "../Admission/AllMeritList"
      },
      semesterChange() {
        this.merit.DegreeID = 0;
      },
      checkMeritListUpdate() {
        var vm = this;
        axios.post('/api/AdmissionApi/loadDegrees')
          .then(function (d) {
            vm.degrees = d.data.lst;
            vm.merit.EffectiveFrom = "" //d.data.dateFrom;
            vm.merit.EffectiveTo = "";
            startReq();
            axios.post('/api/AdmissionApi/loadActiveSemesters')
              .then(function (sem) {
                vm.semesters = sem.data.lst;
                axios.post('/api/AdmissionApi/loadAdmissionCategories')
                  .then(function (cat) {
                    vm.categories = cat.data.data;
                    axios.post('/api/AdmissionApi/checkMeritListUpdate')
                      .then(function (res) {
                        if (res.data.status) {
                          var data = res.data.merit;
                          console.log(data);
                          axios.post('/api/AdmissionApi/loadProgramDegreeDepartmentWise?degID=' + data.DegreeID + '&semID=' + data.ActiveSemesterID)
                            .then(function (p) {
                              vm.isupdate = true;
                              vm.programs = p.data.program;
                              vm.tests = p.data.test;
                              vm.top = res.data.top;
                              vm.candidates = res.data.candidates;
                              vm.waitingList = res.data.waitingList;
                              vm.merit = data;
                              vm.top = res.data.top;
                              vm.waiting = res.data.waiting;

                              //CKEDITOR.instances['header'].setData(vm.merit.Header);
                              //CKEDITOR.instances['footer'].setData(vm.merit.Footer);

                              endReq();
                            });
                        }
                        else {
                          endReq();
                        }
                        endReq();
                      })
                      .catch(function (res) {
                        console.log(res.data);

                      });
                  })
              })

          })

          .catch(function (d) {
            console.log(d);
          });

      },
      degreeChange() {
        startReq();
        var vm = this;
        axios.post('/api/AdmissionApi/loadProgramDegreeDepartmentWise?degID=' + vm.merit.DegreeID + "&semID=" + vm.merit.ActiveSemesterID)
          .then(function (p) {
            vm.programs = p.data.program;
            vm.merit.InterviewOffered = p.data.inter;
            vm.tests = p.data.test;
            endReq();
          });
      },

      save(e) {
        e.preventDefault();
        var vm = this;

        if (vm.merit.Name === "") {
          toastr.error("Title is required", "Error!");
          return;
        }

        else if (vm.candidates.length == 0) {
          toastr.error("Atleast 1 applicant is required for merit list", "Error!");
          return;
        }
        //vm.merit.Header = CKEDITOR.instances['header'].getData();
        //vm.merit.Footer = CKEDITOR.instances['footer'].getData();
        startReq();
        axios.post('/api/AdmissionApi/newMeritList', {
          candidates: vm.candidates,
          waitingList: vm.waitingList,
          merit: vm.merit
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              endReq();
              if (res.data.status) {
                toastr.success("Saved successfully", "Done!");
                setTimeout(function () { window.location.href = "../Admission/AllMeritList" }, 1000);
              }
              else if (!res.data.status) {
                toastr.info("Another merit list is already existed please Lock it to make new merit list", "Info!");
              }
              else {
                toastr.error("Error", "Error!");
              }
            }
            else
              toastr.error(res.data.error);

          })
          .catch(function (err) {
            endReq();
            if (err.response) {
              var res = err.response;
              if (res.status == 401) {
                toastr.error(res.data);
              }
              else {
                for (const [key, value] of Object.entries(res.data.errors)) {
                  //console.log(`${value}`);
                  toastr.error(`${value}`);
                }
              }
            }
          })
      },


      loadCandidates() {
        var vm = this;


        if (vm.merit.Type == 'Top') {
          vm.merit.MinimumAggregate = 0;
          vm.merit.MaximumAggregate = 100;
        }

        if (vm.merit.ActiveSemesterID == 0) {
          toastr.error("Session is required");
          return;
        }

        if (vm.merit.DegreeID == 0) {
          toastr.error("Degree is required");
          return;
        }

        if (vm.merit.ProgramID == "") {
          toastr.error("Program is required");
          return;
        }

        if (vm.merit.Interview == "Appeared" && vm.merit.InterviewScore == "") {
          toastr.error("Minimum interview score is required");
          return;
        }

        if (vm.merit.Gat == "Appeared" && vm.merit.GatScore == "") {
          toastr.error("Minimum gat score is required");
          return;
        }

        if (vm.merit.Type == "Range" && vm.merit.MinimumAggregate < 0) {
          toastr.error("Minimum Aggregate is required");
          return;
        }

        if (vm.merit.Type == "Range" && vm.merit.MaximumAggregate < 0) {
          toastr.error("Maximum Aggregate is required");
          return;
        }

        if (vm.MaximumAggregate > 100) {
          toastr.error("Aggregate range must be in between 0 - 100");
          return;
        }

        if (vm.merit.Type != "Range" && vm.top == "") {
          toastr.error("No of students is required");
          return;
        }

        if (vm.merit.Type == "Range" && (vm.merit.MaximumAggregate == '' || vm.merit.MinimumAggregate == '')) {
          toastr.error("Minimum & Maximum aggregata is required");
          return;
        }

        if (vm.merit.AdmissionType == "" && vm.merit.AdmissionType == null) {
          toastr.error("Admission Type is required");
          return;
        }

        startReq();
        axios.post('/api/AdmissionApi/loadMeritListCandidates?top=' + vm.top + '&waiting=' + vm.waiting, {
          data: vm.merit,
        })
          .then(function (res) {
            endReq();

            //var result = res.data.replace('{"d":null}', '');
            //var data = JSON.parse(result);

            if (!res.data.status) {
              toastr.info("No student found", "Info!");
              vm.candidates = [];
            }
            else {
              vm.candidates = res.data['lst'];
              vm.waitingList = res.data['waitingList'] ? res.data['waitingList'] : [];
            }
          })
          .catch(function (res) {
            endReq();

          });
      },


      updateEntryTest() {
        var vm = this;


        if (vm.merit.Name === "") {
          toastr.error("Title is required", "Error!");
          return;
        }

        else if (vm.candidates.length == 0) {
          toastr.error("Atleast 1 applicant is required for merit list", "Error!");
          return;
        }

        //vm.merit.Header = CKEDITOR.instances['header'].getData();
        //vm.merit.Footer = CKEDITOR.instances['footer'].getData();
        startReq();
        axios.post('/api/AdmissionApi/updateMeritList', {
          candidates: vm.candidates,
          waitingList: vm.waitingList,
          merit: vm.merit
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Saved successfully", "Done!");
              setTimeout(function () { window.location.href = "../Admission/AllMeritList" }, 1000);
            }
            else if (res.data.status === "already") {
              toastr.info("Another merit list is already existed please Lock it to make new merit list", "Info!");
            }
            else {
              toastr.error("Error", "Error!");
            }
          })
          .catch(function (res) {
            console.log(res.data);
          });
      },

  

    }

  })
</script>



// WEBPACK FOOTER //
// src/components/onlineadmission/newMeritList.vue